import * as React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@repo/ui/primitives/button";
import { Input } from "@repo/ui/primitives/input";
import { Label } from "@repo/ui/primitives/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@repo/ui/primitives/card";
import { authIntegration } from "@/lib/api/client";

export default function ActivateAccountPage() {
  const { t } = useTranslation("login");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!token) return;
    setLoading(true);
    try {
      const res = await authIntegration.activateAccount({
        token,
        password,
        confirmPassword,
      });
      if (res.success) {
        navigate("/login", { replace: true });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-svh items-center justify-center bg-background p-[var(--ds-space-6)] text-foreground">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>
            {t("activateAccount.title", { defaultValue: "Account Activation" })}
          </CardTitle>
          <CardDescription>
            {t("activateAccount.description", {
              defaultValue: "Complete your account by setting your password.",
            })}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSubmit} className="space-y-[var(--ds-space-4)]">
            <div className="space-y-2">
              <Label htmlFor="password">
                {t("form.passwordLabel", { defaultValue: "Password" })}
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={6}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="confirm">
                {t("activateAccount.confirmLabel", { defaultValue: "Confirm password" })}
              </Label>
              <Input
                id="confirm"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                minLength={6}
                required
              />
            </div>
            <Button type="submit" className="w-full" disabled={loading || !token}>
              {loading
                ? t("activateAccount.submitLoading", { defaultValue: "Saving…" })
                : t("activateAccount.submit", { defaultValue: "Activate" })}
            </Button>
            {!token && (
              <p className="text-sm text-[var(--destructive-tint-foreground)]" role="alert">
                {t("activateAccount.invalidLink", {
                  defaultValue: "Invalid or incomplete link.",
                })}
              </p>
            )}
          </form>
        </CardContent>
      </Card>
    </main>
  );
}
